import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { PasswordlessMethodChange, SettingsFrame } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useCurrentProject } from '../../../contexts/settings';
import { RouteParams } from '../../../routes/types';

const PasswordlessTypePage = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { currentProjectFetching, currentProject, currentProjectType, error } =
    useCurrentProject(projectId);

  if (currentProjectFetching) {
    return <Preloader />;
  }

  if (error) {
    return <ToDashboardError pageName="passwordless-method_open" error={error} />;
  }

  return (
    <SettingsFrame projectId={projectId} projectType={currentProjectType}>
      <PasswordlessMethodChange currentProject={currentProject} />
    </SettingsFrame>
  );
};

export default withRouter(PasswordlessTypePage);
